import * as React from 'react';
import Link from 'components/Link';
import Head from 'components/Head';
import Navbar from 'components/Navbar';
import Footer from 'layouts/Footer';
import LogoDark from 'svg/logo-dark';
import PricingCards from 'components/PricingCards';
import Card from 'components/Card';
import PromoButton from 'components/PormoButton';
import { getIsNativePlatform } from 'utils/client/mobile';

import { LOGOUT_PAGE } from 'constants/pages';
import { TIME_DELAY, SHOW_BANNER_CONDITION } from 'constants/topBannerConfig';

import { useShowBannerConditions } from 'hooks/useShowBanner';

import { LogoBackground, LogoutButton } from './styles';

const TITLE = 'Pricing';
const DESCRIPTION =
  'Create a subscription for the InsiderFinance trading community. Get our all-inclusive trading service.';

const PricingPage = () => {
  const showBanner = useShowBannerConditions({
    timeDelay: TIME_DELAY,
    additionalCondition: () => SHOW_BANNER_CONDITION() as true,
  });

  return (
    <>
      <Head title={TITLE} description={DESCRIPTION} useCurrentUrl />
      {!getIsNativePlatform() ? (
        <div className="relative z-10">
          <Navbar discountBanner shouldRequireScrollForDiscount={false} />
          <div className="mt-28">
            {showBanner && (
              <div className="py-8">
                <PromoButton />
              </div>
            )}
            <PricingCards />
          </div>
          <div className="mt-28">
            <Footer />
          </div>
        </div>
      ) : (
        <div className="safearea-pad-top">
          <Navbar isStatic />
          <div className="relative z-10 mt-8 p-4">
            <Card>
              <div className="p-2">
                <div className="leading-normal text-gray-300">
                  This app is for active InsiderFinance subscribers. To join the InsiderFinance
                  trading community and see additional benefits of our service, visit our website.
                </div>
                <a
                  className="mt-4 block font-semibold underline"
                  href="https://www.insiderfinance.io"
                >
                  https://www.insiderfinance.io
                </a>
              </div>
            </Card>
            <div className="mt-4 text-center">
              <Link href={LOGOUT_PAGE}>
                <LogoutButton>Logout</LogoutButton>
              </Link>
            </div>
          </div>
        </div>
      )}
      <LogoBackground>
        <LogoDark />
      </LogoBackground>
    </>
  );
};

export default PricingPage;
